import ChangeLogView from './changeLogView'

export default ChangeLogView
